import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from './AuthContext';
import CustomerEdit from './CustomerEdit';
import { motion } from 'framer-motion';

function CustomerList({ refresh }) {
  const { user } = useAuth();
  const [customers, setCustomers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showEditModal, setShowEditModal] = useState(false);
  const [selectedCustomer, setSelectedCustomer] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const navigate = useNavigate();

  const fetchCustomers = () => {
    if (!user) {
      setLoading(false);
      return;
    }
    fetch(`https://www.kenan.bybello.com/backend/api/customers.php?user_id=${user.id}`, {
      credentials: 'include',
    })
      .then(res => {
        if (!res.ok) {
          throw new Error('Müşteri listesi çekilemedi.');
        }
        return res.json();
      })
      .then(data => {
        const userCustomers = data.filter(c => c.user_id === user.id);
        setCustomers(userCustomers);
        setLoading(false);
      })
      .catch(error => {
        console.error('Müşteri listesi çekilirken hata:', error);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCustomers();
  }, [refresh, user]);

  const filteredCustomers = customers.filter(customer =>
    customer.name.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleDelete = (id) => {
    if (window.confirm("Bu müşteriyi silmek istediğinizden emin misiniz?")) {
      fetch('https://www.kenan.bybello.com/backend/api/customers.php', {
        method: 'DELETE',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: `id=${id}`
      })
        .then(res => res.json())
        .then(data => {
          if (data.success) {
            alert("Müşteri başarıyla silindi.");
            fetchCustomers();
          } else {
            alert(data.error || 'Silme işlemi başarısız.');
          }
        })
        .catch(() => alert('Silme işlemi sırasında ağ hatası.'));
    }
  };

  const handleEditClick = (customer) => {
    setSelectedCustomer(customer);
    setShowEditModal(true);
  };

  const handleCustomerUpdated = () => {
    setShowEditModal(false);
    fetchCustomers();
  };

  if (loading) return <div className="container mt-4">Yükleniyor...</div>;
  if (!user) return <div className="container mt-4 alert alert-warning">Lütfen giriş yapın.</div>;

  return (
    <div className="container mt-4">
      <div className="mb-3">
        <input
          type="text"
          className="form-control"
          placeholder="Müşteri adına göre ara..."
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
        />
      </div>
      <h2>Müşteri Listesi</h2>
      <table className="table table-bordered table-striped">
        <thead>
          <tr>
            <th>Adı</th>
            <th>Telefon</th>
            <th>Adres</th>
            <th>Güncel Bakiye</th>
            <th>İşlemler</th>
          </tr>
        </thead>
        <tbody>
          {filteredCustomers.length === 0 ? (
            <tr><td colSpan="5">Henüz müşteri yok veya arama sonucu bulunamadı.</td></tr>
          ) : (
            filteredCustomers.map((c, idx) => (
              <motion.tr
                key={c.id}
                initial={{ opacity: 0, y: 30 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.4, delay: idx * 0.05 }}
              >
                <td><Link to={`/customer/${c.id}`}>{c.name}</Link></td>
                <td>{c.phone}</td>
                <td>{c.address}</td>
                <td>{parseFloat(c.balance).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY', minimumFractionDigits: 2 })}</td>
                <td>
                  <button onClick={() => navigate(`/customer/${c.id}`)} className="btn btn-info btn-sm me-2">Müşteri Detay</button>
                  <button onClick={() => handleEditClick(c)} className="btn btn-warning btn-sm me-2">Düzenle</button>
                  <button onClick={() => handleDelete(c.id)} className="btn btn-danger btn-sm">Sil</button>
                </td>
              </motion.tr>
            ))
          )}
        </tbody>
      </table>

      {showEditModal && selectedCustomer && (
        <>
          <div className="modal-backdrop fade show"></div>
          <div className="modal show d-block" tabIndex="-1" style={{ display: 'block' }}>
            <div className="modal-dialog">
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Müşteri Düzenle</h5>
                  <button type="button" className="btn-close" onClick={() => setShowEditModal(false)}></button>
                </div>
                <div className="modal-body">
                  <CustomerEdit
                    customerData={selectedCustomer}
                    userId={user.id}
                    onCustomerUpdated={handleCustomerUpdated}
                  />
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default CustomerList;
